import { EFontSize } from '../../../interface/fontSize';

type TObjectType = {
    key: EFontSize;
    value: string;
    isDefault?: boolean;
 }

 const fontSizeSwitchList: TObjectType[] = [
     {
         key: EFontSize.SMALL,
         value: '默认字号',
         isDefault: true,
     },
     {
         key: EFontSize.MIDDLE,
         value: '大字号',
     },
     {
         key: EFontSize.LARGE,
         value: '最大字号',
     },
 ];

 export { fontSizeSwitchList };
